import React, { useEffect, useState } from 'react';
import CombatProEngineApp from './combatpro/CombatProEngineApp';
import { setupCombatProPwa } from './combatpro/pwa';

// Combat PRO renders the modular in-app engine (customer-portal/src/combatpro)
// instead of redirecting to the legacy hosted battletracker.html. The official
// monster / spell databases are provisioned exactly as the legacy page did: via
// the same versioned data scripts, which set the window.VI_*_DB globals the
// engine reads. A missing or blocked script degrades gracefully to an empty
// official DB (custom monsters / spells still work). Auth, entitlement, and the
// route are unchanged: this component is still reached only through the
// PrivateRoute-gated /battletracker route, after the Dashboard combat_system_pro
// entitlement check.

const DB_SCRIPTS = [
  'https://app.visinvoke.com/data/spells-db.v1.js',
  'https://app.visinvoke.com/data/monsters-db.v1.js',
];

function ensureScript(src) {
  return new Promise(function (resolve) {
    var already = Array.prototype.slice.call(document.scripts).some(function (s) { return s.src === src; });
    if (already) { resolve(); return; }
    var el = document.createElement('script');
    el.src = src;
    el.async = false;
    el.onload = function () { resolve(); };
    el.onerror = function () { resolve(); };
    document.head.appendChild(el);
  });
}

export default function BattleTracker() {
  const [ready, setReady] = useState(false);

  useEffect(function () {
    var alive = true;
    (async function () {
      for (var i = 0; i < DB_SCRIPTS.length; i++) {
        // eslint-disable-next-line no-await-in-loop
        await ensureScript(DB_SCRIPTS[i]);
      }
      if (alive) { setReady(true); }
    })();
    return function () { alive = false; };
  }, []);

  // Combat PRO PWA setup, scoped to this route only (manifest + Apple standalone
  // meta + hardened cache-free service worker). Cleans up on unmount.
  useEffect(function () {
    var teardown = setupCombatProPwa();
    return function () { if (typeof teardown === 'function') { teardown(); } };
  }, []);

  if (!ready) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0B0F14', color: '#F0B429', fontFamily: 'Segoe UI, system-ui, sans-serif', fontWeight: 700, letterSpacing: '1px' }}>
        Loading Combat PRO...
      </div>
    );
  }

  return <CombatProEngineApp />;
}
